import { HorizontalView } from "../../../../_components/Abstractions/HorizontalView";
import { FormControl } from "../../../../_components/Forms/FormControl";

export function UsedContainerWastesForm({ name }) {
  return <HorizontalView columnsSize={[9,3]}>
         <FormControl readonly name={`${name}.displayDescription`} label="Towar"/>
         <FormControl name={`${name}.count`} label="Ilość" inputType="numeric"/>
       </HorizontalView>
}